export default "__VITE_ASSET__BdssT$ox__"